<template>
  <div class="identifier">
    <input-field
      v-if="
        formData.field_Login && formData.field_Login.visible && !isAuthentified
      "
      fieldId="Login"
      :name="formData.field_Login.name"
      :description="formData.field_Login.description"
      :tooltip="formData.field_Login.tooltip"
      :required="formData.field_Login.required"
      :enabled="formData.field_Login.enabled"
      :pattern="formData.field_Login.regexp"
      v-model="userData.login"
    ></input-field>
    <input-fixed-field
      v-else-if="formData.field_Login && formData.field_Login.visible"
      fieldId="Login"
      :name="formData.field_Login.name"
      :description="formData.field_Login.description"
      :tooltip="formData.field_Login.tooltip"
      :required="formData.field_Login.required"
      :enabled="formData.field_Login.enabled"
      :pattern="formData.field_Login.regexp"
      v-model="userData.login"
    ></input-fixed-field>

    <div v-if="!isAuthentified">
      <input-field
        v-if="formData.field_Password && formData.field_Password.visible"
        fieldId="Password"
        :name="formData.field_Password.name"
        :description="formData.field_Password.description"
        :tooltip="formData.field_Password.tooltip"
        :required="formData.field_Password.required"
        :enabled="formData.field_Password.enabled"
        :pattern="formData.field_Password.regexp"
        v-model="userData.password"
        type="password"
      ></input-field>
      <input-field
        v-if="
          formData.field_ConfirmPassword &&
            formData.field_ConfirmPassword.visible
        "
        fieldId="ConfirmPassword"
        :name="formData.field_ConfirmPassword.name"
        :description="formData.field_ConfirmPassword.description"
        :tooltip="formData.field_ConfirmPassword.tooltip"
        :required="formData.field_ConfirmPassword.required"
        :enabled="formData.field_ConfirmPassword.enabled"
        :pattern="formData.field_ConfirmPassword.regexp"
        v-model="userData.confirmPassword"
        type="password"
        :customRules="{ confirmed: 'Password' }"
      ></input-field>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import InputField from "./InputField.vue";
import InputFixedField from "./InputFixedField.vue";

export default Vue.extend({
  name: "identifier-fields",

  components: {
    InputField,
    InputFixedField
  },

  props: {
    formData: {
      type: Object,
      required: true
    },
    userData: {
      type: Object,
      required: true
    },
    isAuthentified: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {};
  },

  computed: {},

  methods: {},

  watch: {}
});
</script>

<style scoped></style>
